import React from 'react'
import SVG from 'react-inlinesvg'
import styled from 'styled-components'

import PrevEl from 'assets/icons/arrowRight.svg'
import { breakpointUpTo } from 'utils/breakpoints'

type ButtonProps = {
  position: 'prev' | 'next'
  className: string
}
export const StyledButton = styled.button<ButtonProps>`
  position: absolute;
  margin: 0;
  padding: 0;
  top: 50%;
  ${({ position }) => (position === 'prev' ? 'left: -94px' : 'right: -94px')};
  display: flex;
  place-items: center;
  justify-content: space-around;
  transform: translateY(-50%);
  background-color: ${({ theme }) => theme.colors.black};
  border: none;
  cursor: pointer;
  z-index: 1;
  width: 64px;
  height: 64px;
  transition: 0.2s background-color;
  border-radius: 50%;
  &:hover {
    background-color: ${({ theme }) => theme.colors.brown};
  }
  &.swiper-button-disabled {
    display: none;
  }
  svg {
    transform: rotate(
        ${({ position }) => (position === 'prev' ? '180deg' : '0')}
      )
      translateX(20%);
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.lg)} {
    ${({ position }) => (position === 'prev' ? 'left: -72px' : 'right: -72px')};
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    ${({ position }) => (position === 'prev' ? 'left: -24px' : 'right: -24px')};
    width: 54px;
    height: 54px;
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    width: 48px;
    height: 48px;
    svg {
      height: 15px;
      width: 10px;
    }
  }
`
export const CarouselButton = (props: ButtonProps) => (
  <StyledButton {...props} aria-label={'Carousel button'}>
    <SVG src={PrevEl} />
  </StyledButton>
)
